module.exports = __webpack_public_path__ + "img/is-primary.ff385bd0.svg";